<template>
  <div class="point-card">
    <div class="point-card__image" :class="{ 'point-card__image--empty': !item.image }">
      <img v-if="item.image" :src="item.image" class="img-fluid" />
      <button
        v-if="showPreviewButton"
        class="point-card__preview-btn"
        @click="handlePreview"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"/>
        </svg>
      </button>
    </div>
    <div class="point-card__content">
      <div class="point-card__date" v-if="item.start_at || item.end_at">{{ formattedDate(item.start_at) }} ~ {{ formattedDate(item.end_at) }}</div>
      <div class="point-card__date" v-else>{{ item.date || '' }}</div>
      <div class="point-card__title">{{ item.name }}</div>
      <!--<div class="point-card__subtitle">{{ item.subtitle }}</div>-->
      <div class="point-card__bottom s-flex s-items-center s-justify-between">
        <div v-if="noPoint" class="point-card__free">無法兌換</div>
        <div v-else-if="!item.point" class="point-card__free">免費領取</div>
        <div v-else class="point-card__point">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="10" cy="10" r="10" fill="currentcolor"/>
            <path
              d="M6.91 5.718V15H8.431V11.438H10.732C12.994 11.438 14.125 10.476 14.125 8.565C14.125 6.667 12.994 5.718 10.758 5.718H6.91ZM8.431 7.018H10.641C11.304 7.018 11.798 7.135 12.11 7.382C12.422 7.616 12.591 8.006 12.591 8.565C12.591 9.124 12.435 9.527 12.123 9.774C11.811 10.008 11.317 10.138 10.641 10.138H8.431V7.018Z"
              fill="white"
            />
          </svg>

          {{ item.point.toLocaleString() }}
        </div>

        <div v-if="isRedeemed" class="point-card__redeemed">
          <img src="@/pages/Dashboard/Point/stamp-redeemed.png" />
          <!-- <button class="s-btn s-liff-theme-btn-outline s-btn-xs" type="button">
            前往使用
          </button> -->
        </div>
        <div v-else class="point-card__button">
          <button v-if="isNotYetExchangeable"
            class="s-btn s-liff-theme-btn-outline s-btn-xs btn-not-enough"
            type="button"
            disabled
          >
            尚未開放
          </button>
          <button v-else-if="isExpired"
            class="s-btn s-liff-theme-btn-outline s-btn-xs btn-not-enough"
            type="button"
            disabled
          >
            已過期
          </button>
          <button v-else-if="noPoint"
            class="s-btn s-liff-theme-btn-outline s-btn-xs btn-not-enough"
            type="button"
          >
            無法兌換
          </button>
          <button v-else-if="item.quantity <= 0"
            class="s-btn s-liff-theme-btn-outline s-btn-xs btn-not-enough"
            type="button"
          >
            已兌換完畢
          </button>
          <button v-else-if="item.point > availablePoints"
            class="s-btn s-liff-theme-btn-outline s-btn-xs btn-not-enough"
            type="button"
          >
            點數不足
          </button>
          <button v-else
            class="s-btn s-liff-theme-btn-outline s-btn-xs btn-exchange"
            @click="handleExchange(item)"
            type="button"
            :disabled="item.point === null"
          >
            兌換
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format, isAfter, isBefore, parseISO } from "date-fns"
import { mapGetters } from "vuex";

export default {
  props: {
    item: {
      type: Object,
      default: () => ({
        id: 1,
        name: "珐瑯不銹鋼 雙層隨行杯",
        subtitle: "藍色",
        point: 10000,
        status: 1,
      }),
    },
    isRedeemed: {
      type: Boolean,
    },
    showPreviewButton: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters('liffPoint', [
      'availablePoints',
    ]),
    noPoint() {
      return typeof this.item.point === 'undefined'
    },
    isNotYetExchangeable() {
      return isBefore(new Date(), parseISO(this.item.start_at))
    },
    isExpired() {
      return isAfter(new Date(), parseISO(this.item.end_at))
    },
  },

  methods: {
    formattedDate(date) {
      if (!date) return '';
      return format(parseISO(date), 'yyyy/MM/dd');
    },
    handleExchange(item) {
      this.$emit("exchange", item);
    },
    handlePreview() {
      this.$emit("preview", this.item);
    },
  },
};
</script>

<style lang="scss" scoped>
.point-card {
  display: flex;
  background: white;
  border: 1px solid #e5e5ea;
  margin-bottom: 12px;
  position: relative;
  overflow: hidden;

  .point-card__content {
    padding: 12px;
    width: 100%;
  }

  &__date {
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    color: #979797;
    margin-bottom: 8px;
    font-family: "PingFang TC";
  }

  &__title {
    font-weight: 600;
    font-size: 18px;
    line-height: 18px;
    color: #2c2c2e;
    margin-bottom: 8px;
  }

  &__subtitle {
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    letter-spacing: -0.408px;
    color: #2c2c2e;
    margin-bottom: 6px;
  }

  &__image {
    aspect-ratio: 1 / 1;
    flex: 0 0 90px;
    position: relative;
    height: 90px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      aspect-ratio: 1;
    }

    &--empty {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: var(--liff-header-color);
      color: white;

      &:before {
        content: "";
        display: inline-block;
        width: 35px;
        height: 35px;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23FFF' d='M321.5 68.8C329.1 55.9 342.9 48 357.8 48l2.2 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-73.3 0 34.8-59.2zm-131 0l34.8 59.2-73.3 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l2.2 0c14.9 0 28.8 7.9 36.3 20.8zm89.6-24.3l-24.1 41-24.1-41C215.7 16.9 186.1 0 154.2 0L152 0c-48.6 0-88 39.4-88 88 0 14.4 3.5 28 9.6 40L32 128c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-41.6 0c6.1-12 9.6-25.6 9.6-40 0-48.6-39.4-88-88-88l-2.2 0c-31.9 0-61.5 16.9-77.7 44.4zM480 272l-200 0 0 208 136 0c35.3 0 64-28.7 64-64l0-144zm-248 0l-200 0 0 144c0 35.3 28.7 64 64 64l136 0 0-208z'/%3E%3C/svg%3E");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
      }
    }
  }

  &__free {
    font-weight: 600;
    font-size: 15px;
    line-height: 32px;
    color: var(--liff-button-color);
  }

  &__point {
    font-weight: 600;
    font-size: 20px;
    line-height: 32px;
    color: var(--s-primary);
    font-family: "PingFang TC";
    display: flex;
    align-items: center;
    svg {
      margin-right: 4px;
    }
  }

  &__button {
    button {
      font-size: 13px;
      line-height: 18px;
      padding: 6px 16px;
      font-weight: 600;
    }

    .btn-not-enough {
      background: #e5e5ea;
      border: 1px solid #c0c4cc;
      color: #2c2c2e;
      cursor: not-allowed;
    }
  }

  &__redeemed {
    position: absolute;
    right: 10px;
    transform: rotate(-30deg);
    bottom: -20px;
    img {
      width: 80px;
    }
  }

  &__preview-btn {
    position: absolute;
    bottom: 5px;
    right: 5px;
    width: 30px;
    height: 30px;
    border-radius: .4rem;
    background: rgba(255, 255, 255, 0.3);
    padding: .35rem;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    cursor: pointer;

    svg {
      width: 100%;
      height: 100%;
      fill: #333;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.5);
      transform: scale(1.05);
    }

    &:active {
      transform: scale(0.95);
      background: rgba(255, 255, 255, 0.6);
    }

    &:focus {
      outline: none;
      box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.8);
    }
  }
}
</style>
